import { wait } from "@krainovsd/js-helpers";
import { type NavigationGuardWithThis, createRouter, createWebHistory } from "vue-router";
import AccountPage from "@/pages/AccountPage/AccountPage.vue";
import BayesianComparePage from "@/pages/BayesianComparePage/BayesianComparePage.vue";
import BriefPage from "@/pages/BriefPage/BriefPage.vue";
import BriefsPage from "@/pages/BriefsPage/BriefsPage.vue";
import ComparisonPage from "@/pages/ComparisonPage/ComparisonPage.vue";
import CreateComparisonPage from "@/pages/CreateComparisonPage/CreateComparisonPage.vue";
import CreateReportPage from "@/pages/CreateReportPage/CreateReportPage.vue";
// import CreateSubscriptionTemplate from "@/pages/CreateSubscriptionTemplate/CreateSubscriptionTemplate.vue";
import FactorComparisonPage from "@/pages/FactorComparisonPage/FactorComparisonPage.vue";
import ReportPage from "@/pages/ReportPage/ReportPage.vue";
import StatisticsPage from "@/pages/StatisticsPage/StatisticsPage.vue";
// import SubscriptionPage from "@/pages/SubscriptionPage/SubscriptionPage.vue";
import { PAGES } from "@/entities/tech";

const accessGuard: NavigationGuardWithThis<undefined> = async () => {
  const hasAccess = true;
  await wait(0);
  if (!hasAccess) {
    return { name: PAGES.Denied };
  }
  return undefined;
};

const MAIN_PAGE = StatisticsPage;
const MAIN_PAGE_NAME = PAGES.Statistics;

export const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: "/",
      component: MAIN_PAGE,
      name: MAIN_PAGE_NAME,
      beforeEnter: [accessGuard],
    },
    {
      path: "/statistics",
      name: PAGES.Statistics,
      component: StatisticsPage,
      beforeEnter: [accessGuard],
    },
    {
      path: "/report",
      name: PAGES.ReportByFilters,
      component: ReportPage,
      beforeEnter: [accessGuard],
    },
    {
      path: "/report/:id",
      name: PAGES.Report,
      component: ReportPage,
      beforeEnter: [accessGuard],
    },
    {
      path: "/create-report",
      name: PAGES.CreateReport,
      component: CreateReportPage,
      beforeEnter: [accessGuard],
    },
    {
      path: "/compare",
      name: PAGES.Compare,
      component: ComparisonPage,
      beforeEnter: [accessGuard],
    },
    {
      path: "/create-comparison",
      name: PAGES.CreateComparison,
      component: CreateComparisonPage,
      beforeEnter: [accessGuard],
    },
    {
      path: "/compare/:id",
      name: PAGES.FactorComparison,
      component: FactorComparisonPage,
      beforeEnter: [accessGuard],
    },
    {
      path: "/compare-bayesian/:id",
      name: PAGES.BayesianCompare,
      component: BayesianComparePage,
      beforeEnter: [accessGuard],
    },
    {
      path: "/account",
      name: PAGES.Account,
      component: AccountPage,
      beforeEnter: [accessGuard],
    },
    // {
    //   path: "/subscription",
    //   name: PAGES.Subscription,
    //   component: SubscriptionPage,
    //   beforeEnter: [accessGuard],
    // },
    // {
    //   path: "/create-subscription",
    //   name: PAGES.CreateSubscription,
    //   component: CreateSubscriptionTemplate,
    //   beforeEnter: [accessGuard],
    // },
    // {
    //   path: "/create-subscription/:id",
    //   name: PAGES.EditSubscription,
    //   component: CreateSubscriptionTemplate,
    //   beforeEnter: [accessGuard],
    // },
    {
      path: "/stats/briefs",
      name: PAGES.Briefs,
      component: BriefsPage,
      beforeEnter: [accessGuard],
    },
    {
      path: "/stats/briefs/:id",
      name: PAGES.Brief,
      component: BriefPage,
      beforeEnter: [accessGuard],
    },
    { path: "/error", name: PAGES.Error, component: () => import("@/pages/ErrorPage.vue") },
    {
      path: "/:pathMatch(.*)*",
      component: MAIN_PAGE,
      name: MAIN_PAGE_NAME,
    },
  ],
  scrollBehavior: () => {
    return { top: 0, behavior: "smooth" };
  },
});
